import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from './local-storage.service';
import { NavigationService } from './navigation.service';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertMessageComponent } from '../components/alert-message/alert-message.component';

@Injectable({
    providedIn: 'root'
})
export class HttpService {

    public BASE_URL = environment.API_BASE_URL;

    constructor(
        private http: HttpClient,
        private localStorageService: LocalStorageService,
        private navigateService: NavigationService,
        private modalService: NgbModal,
    ) { }

    private getTokenHeader(httpHeaders: HttpHeaders): HttpHeaders {
        let user = this.localStorageService.getUser();
        if (user != null && user.token) {
            httpHeaders = httpHeaders.append('Authorization', `Bearer ${user.token}`);
        }
        return httpHeaders;
    }

    private buildHeaders(setToken: boolean): HttpHeaders {
        let httpHeaders: HttpHeaders = new HttpHeaders();
        httpHeaders = httpHeaders.append('Content-Type', 'application/json');
        if (setToken) {
            httpHeaders = this.getTokenHeader(httpHeaders);
        }
        return httpHeaders;
    }

    private buildHeadersMultiPart(setToken: boolean): HttpHeaders {
        let httpHeaders: HttpHeaders = new HttpHeaders();
        if (setToken) {
            httpHeaders = this.getTokenHeader(httpHeaders);
        }
        return httpHeaders;
    }

    /*public login(url: string, email: string): Observable<any> {
        let request = {
            Email: email
        }
        let httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<any>(this.baseUrl + url, request, {
            headers: httpHeaders
        }).pipe(
            map(response => {
                return response;
            }),
            catchError(error => {
                this.catchResponse(error);
                return throwError(error);
            })
        );
    }*/

    /*public autoLogin(url: string, token: string): Observable<sessionDTO> {
        let httpParams = new HttpParams();
        httpParams = httpParams.append('emailToken', token);
        let httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<sessionDTO>(this.baseUrl + url, {}, {
            headers: httpHeaders, params: httpParams
        }).pipe(
            map(response => {
                if (response.Token) {
                    this.localStorageService.setSession(response);
                    return response;
                }
            }),
            catchError(error => {
                this.catchResponse(error);
                return throwError(error);
            })
        );
    }*/

    public request<T>(method: string, url: string, body: any = null, httpParams: HttpParams = null, setToken: boolean = true): Observable<T> {
        return this.http.request<T>(method, this.BASE_URL + url, { headers: this.buildHeaders(setToken), params: httpParams ? httpParams : null, body: body })
        .pipe(
            map(response => {
                return response;
            }),
            catchError(error => {
                this.catchResponse(error);
                return throwError(error);
            })
        );
    }

    public get<T>(url: string, httpParams: HttpParams = null, setToken: boolean = true): Observable<T> {
        return this.http.get<T>(this.BASE_URL + url, { headers: this.buildHeaders(setToken), params: httpParams ? httpParams : null })
            .pipe(
                map(response => {
                    return response;
                }),
                catchError(error => {
                    this.catchResponse(error);
                    return throwError(error);
                })
            );
    }

    public post<T>(url: string, httpParams: HttpParams = null, data: any, setToken: boolean = true, showError: boolean = true): Observable<T> {
        return this.http.post<T>(this.BASE_URL + url, data, { headers: this.buildHeaders(setToken), params: httpParams ? httpParams : null }).pipe(
            map(response => {
                return response;
            }),
            catchError(error => {
                if (showError) {
                    this.catchResponse(error);
                }
                return throwError(error);
            })
        );
    }

    public postMuiltiPart<T>(url: string, formData: any, setToken: boolean = true): Observable<T> {
        return this.http.post<T>(this.BASE_URL + url, formData, { headers: this.buildHeadersMultiPart(setToken) }).pipe(
            map(response => {
                return response;
            }),
            catchError(error => {
                this.catchResponse(error);
                return throwError(error);
            })
        );
    }

    public put<T>(url: string, data: any, setToken: boolean = true): Observable<T> {
        return this.http.put<T>(this.BASE_URL + url, data, { headers: this.buildHeaders(setToken) }).pipe(
            map(response => {
                return response;
            }),
            catchError(error => {
                this.catchResponse(error);
                return throwError(error);
            })
        );
    }

    public delete<T>(url: string, setToken: boolean = true): Observable<T> {
        return this.http.delete<T>(this.BASE_URL + url, { headers: this.buildHeaders(setToken) }).pipe(
            map(response => {
                return response;
            }),
            catchError(error => {
                this.catchResponse(error);
                return throwError(error);
            })
        );
    }

    private catchResponse(error: HttpErrorResponse) {
        if (error.status == 401) {
            this.navigateService.goToLogin();
        } else {
            console.log("ERROR CATCH ", error.error.statusCode);
            /*this.snackbar.open(error.error.message, 'OK', {
                duration: 10000
            });*/
            //this.appConfirm.confirm({ title: 'Error', message: error.error.Message, showCancel: false });
            if (error && error.error && error.error.statusCode) {

                switch (error.error.statusCode)
                {
                    case "INVALID_TOKEN":
                    case "SURVEY_NOT_ALLOW":
                        this.localStorageService.logout();
                        this.navigateService.goToLogin();
                        break;
                    default:
                        const modalRef = this.modalService.open(AlertMessageComponent, { windowClass: 'animated fadeInDown' });
                        modalRef.componentInstance.msg = 'ERRORS.' + error.error.statusCode;
                        modalRef.result.then((result) => { }, (reason) => { });
                        break;
                }
            }
        }
    }

}
